import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { isEmpty, join, split, trimStart, uniq } from "lodash"

import { clearParcels } from "data/actions/parcels"

import SearchForm from "./SearchForm"

import styles from "./Search.css"

class Search extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    clear: PropTypes.func.isRequired,
    searchForm: PropTypes.object.isRequired,
  }
  static contextTypes = {
    t: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.clearStore = this.clearStore.bind(this)
  }

  handleSubmit(event) {
    event.preventDefault()
    const { searchForm, history } = this.props
    const searchArray = this.createSearchArray(searchForm.search.values.search)
    if (searchArray.length === 1) {
      history.push(`/parcel/${searchArray[0]}`)
      this.clearStore()
    } else if (searchArray.length > 1) {
      history.push({
        pathname: "/parcels",
        query: {
          id: searchArray,
        },
      })
    }
  }

  clearStore() {
    const { clear } = this.props
    clear()
  }

  createSearchArray(str) {
    const formattedStr = this.removeLeadingAndEndingSpacesAndCommas(str)

    return uniq(split(formattedStr, ","))
  }

  removeLeadingAndEndingSpacesAndCommas(str) {
    const newStr = str.replace(/^[,\s]+|[,\s]+$/g, "")
    const trimmedString = newStr.replace(/\s*,\s*/g, ",")

    return trimmedString
  }

  render() {
    const { location } = this.props
    const { t: translate } = this.context
    const singleSearch = location.pathname.indexOf("parcel") > -1 ? trimStart(location.pathname, "/parcel/") : null
    const multipleSearch = join(location.query.id, ", ")

    return (
      <div className={styles.root}>
        <div className="container">
          <h1 className="w300 fs-24 m-t-0 m-b-5">
            {translate("Track your parcel")}
          </h1>
          <SearchForm onSubmit={this.handleSubmit} search={isEmpty(location.query) ? singleSearch : multipleSearch} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  searchForm: state.form,
})

const mapDispatchToProps = dispatch => ({
  clear: () => dispatch(clearParcels()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search))



// WEBPACK FOOTER //
// ./src/shared/components/Search/Search.js